import { createApp } from "vue";
import tabs from "@/components/cpt-Tabs/index.vue";

export default class ComponentTabs {
  dom: HTMLElement;
  // tabs: Array<Tab>;
  content: string;
  articleID: string;

  constructor(dom: any, content: string, articleID: string) {
    this.dom = dom;
    this.content = content;
    this.articleID = articleID;
    this.create();
  }

  create() {
    createApp(tabs, {
      content: this.content,
      articleID: this.articleID,
    }).mount(this.dom);
  }
}
